export enum MessageSendStatus {
  PENDING = 'PENDING',
  ERROR = 'UNPREDICTABLE',
  SUCCESS = 'SUCCESS',
}
